<app-breadcrumb
  listado="/main/alarmas/alarmasDomiciliarias"
  etiquetaListado="Alarmas domiciliarias"
  [titulo]="tituloMiga"
></app-breadcrumb>

<app-crear-editar
  [loading]="cargando"
  [title]="title"
  [subtitle]="subtitle"
  icono="doorbell"
>
  @if (!cargando) {
    <mat-card class="stepper-card">
      <mat-card-content class="form-pasos-layout">
        <!-- Pasos a la izquierda, con su estado; la barra horizontal del
             stepper queda oculta y el contenido del paso va a la derecha -->
        <app-pasos-nav
          [stepper]="stepper"
          etiqueta="Pasos de la alarma"
        ></app-pasos-nav>

        <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 1: INFORMACIÓN BÁSICA -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step
            [stepControl]="formBasica"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>info</mat-icon>
                <span>Básica</span>
              </div>
            </ng-template>

            <form [formGroup]="formBasica" class="step-content">
              <div class="step-grid step-grid-2">
                <!-- Columna izquierda: Formulario -->
                <app-content-card
                  title="Información General"
                  icon="description"
                  color="blue"
                >
                  <div class="form-content">
                    @if (mostrarCamposCliente) {
                      @if (!this.id) {
                        <!-- Cliente propietario -->
                        <div class="field-group">
                          <label class="field-label">
                            <mat-icon>business</mat-icon>
                            Cliente Propietario
                          </label>
                          <div class="field-row">
                            <app-cliente-selector
                              formControlName="idCliente"
                              (clienteChange)="onClienteChange($event)"
                              [filterModules]="['moduloAlarmasDomiciliarias']"
                              [showCrearBtn]="
                                helper.tienePermiso(
                                  'Administración - Crear clientes'
                                )
                              "
                            ></app-cliente-selector>
                          </div>
                        </div>
                      }

                      <!-- Horarios de atención -->
                      <div style="width: 100%">
                        <app-config-horarios-atencion
                          formControlName="configHorariosAtencion"
                          [idClienteFinal]="idCliente"
                        ></app-config-horarios-atencion>
                      </div>

                      <!-- Horarios de atención técnica -->
                      <div style="width: 100%">
                        <app-config-horarios-atencion
                          formControlName="configHorariosAtencionTecnica"
                          titulo="Clientes que Atienden Servicios Técnicos"
                          [idClienteFinal]="idCliente"
                        ></app-config-horarios-atencion>
                      </div>

                      <!-- Puede solicitar servicio técnico -->
                      <div class="field-group">
                        <mat-checkbox
                          color="primary"
                          formControlName="puedeSolicitarServicioTecnico"
                        >
                          Puede solicitar servicio técnico (permite que el
                          cliente genere solicitudes de servicio técnico desde
                          su app)
                        </mat-checkbox>
                      </div>
                    }

                    <!-- Número de abonado -->
                    <div class="form-field-wrapper">
                      <mat-form-field appearance="outline" class="no-hint">
                        <mat-label>Número de abonado</mat-label>
                        <input
                          matInput
                          formControlName="numeroAbonado"
                          (blur)="validarExistencia($event)"
                          required
                        />
                        <mat-icon matPrefix>tag</mat-icon>
                      </mat-form-field>
                      @if (warnNumeroAbonado) {
                        <div class="warning-message">
                          <mat-icon>warning</mat-icon>
                          <span>
                            Ya existe una alarma con este número de abonado en
                            este cliente.
                          </span>
                        </div>
                      }
                    </div>

                    <!-- Nombre -->
                    <div class="form-field-wrapper">
                      <mat-form-field appearance="outline" class="no-hint">
                        <mat-label>Identificación de la alarma</mat-label>
                        <input
                          matInput
                          formControlName="nombre"
                          [errorStateMatcher]="chequeo.matcher"
                          required
                        />
                        <mat-icon matPrefix>label</mat-icon>
                      </mat-form-field>
                      <app-mensaje-identificacion
                        [chequeo]="chequeo"
                      ></app-mensaje-identificacion>
                    </div>

                    <!-- Servicios -->
                    @if (servicios) {
                      <div class="field-group">
                        <label class="field-label">
                          <mat-icon>build</mat-icon>
                          Servicios Contratados
                        </label>
                        <ng-select
                          [items]="servicios"
                          bindLabel="nombre"
                          bindValue="_id"
                          formControlName="idServiciosContratados"
                          [multiple]="true"
                          placeholder="Seleccioná servicios"
                          appendTo="body"
                        >
                          <ng-template ng-option-tmp let-item="item">
                            <div class="service-option">
                              @if (item.icono) {
                                <img
                                  [src]="item.icono"
                                  alt="Logo"
                                  class="service-icon"
                                />
                              }
                              <span>{{ item.nombre }}</span>
                            </div>
                          </ng-template>
                          <ng-template ng-label-tmp let-item="item">
                            <div class="service-option small">
                              @if (item.icono) {
                                <img
                                  [src]="item.icono"
                                  alt="Logo"
                                  class="service-icon small"
                                />
                              }
                              <span>{{ item.nombre }}</span>
                            </div>
                          </ng-template>
                        </ng-select>
                      </div>
                    }
                  </div>
                </app-content-card>

                <!-- Columna derecha: Jerarquía -->
                @if (idCliente) {
                  <app-content-card
                    title="Jerarquía del Cliente"
                    icon="account_tree"
                    color="green"
                  >
                    <div class="hierarchy-container">
                      <app-jerarquia-cliente
                        [idCliente]="idCliente"
                      ></app-jerarquia-cliente>
                    </div>
                  </app-content-card>
                }
              </div>
            </form>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 2: UBICACIÓN -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step
            [stepControl]="formUbicacion"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>location_on</mat-icon>
                <span>Ubicación</span>
              </div>
            </ng-template>

            <form [formGroup]="formUbicacion" class="step-content">
              <app-content-card
                title="Ubicación del Domicilio"
                icon="place"
                color="red"
              >
                <div class="mapa-embebido-wrapper">
                  <app-mapa-ubicar
                    [raster]="'google'"
                    [form]="geojson"
                    [enableButtonCalcular]="true"
                    [direccionElegida]="alarmaEditar?.domicilio?.direccion"
                    [centrarA]="centrarA"
                    [enableAutocomplete]="true"
                    (direccion)="patchDireccion($event)"
                  ></app-mapa-ubicar>
                </div>
              </app-content-card>
            </form>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 3: INFORMACIÓN DETALLADA -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step
            [stepControl]="formDetallada"
            errorMessage="Campos incompletos"
          >
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>settings</mat-icon>
                <span>Detallada</span>
              </div>
            </ng-template>

            <form [formGroup]="formDetallada" class="step-content">
              <!-- Comunicador y Modelo -->
              <app-content-card
                title="Configuración del Dispositivo"
                icon="router"
                color="orange"
              >
                <div class="form-content alineado-sim">
                  <!-- ID Único comunicador: compartido por todos los
                         comunicadores de esta alarma (misma cuenta
                         configurada en cada equipo físico). -->
                  <mat-form-field appearance="outline">
                    <mat-label>ID único de comunicador</mat-label>
                    <input matInput formControlName="idUnicoComunicador" />
                    <mat-icon matPrefix>fingerprint</mat-icon>
                    @if (esDXControl) {
                      <mat-hint>
                        DX Control: el IMEI del módulo (15 dígitos), no la
                        cuenta
                      </mat-hint>
                    }
                    @if (
                      formDetallada
                        .get('idUnicoComunicador')
                        ?.hasError('idExistente')
                    ) {
                      <mat-error>
                        Este ID de comunicador ya existe en una alarma
                      </mat-error>
                    }
                    @if (
                      formDetallada
                        .get('idUnicoComunicador')
                        ?.hasError('required')
                    ) {
                      <mat-error>Este campo es requerido</mat-error>
                    }
                  </mat-form-field>

                  <!-- Modelo de alarma: define si el comunicador hace
                         falta (panel con comunicación integrada, o no). -->
                  <app-modelo-dispositivo-selector
                    tipo="Alarma"
                    formControlName="idModelo"
                    placeholder="Modelo de alarma*"
                    [showCrearBtn]="
                      helper.tienePermiso(
                        'Configuraciones - Crear modelos alarmas'
                      )
                    "
                    (modeloChange)="setFormatoModelo($event)"
                  ></app-modelo-dispositivo-selector>

                  <!-- Comunicadores: uno o más equipos físicos, todos con
                         el mismo ID único de arriba, protocolo/marca
                         distinto entre sí. Se editan todos igual — no hay
                         un "principal" especial, es la lista completa. -->
                  @for (
                    f of comunicadoresForm.controls;
                    track f;
                    let i = $index
                  ) {
                    <div class="comunicador-card" [formGroup]="f">
                      <div class="comunicador-card-header">
                        <span class="comunicador-card-title">
                          <mat-icon>router</mat-icon>
                          Comunicador {{ i + 1 }}
                        </span>
                        <button
                          irxBotonIcono
                          tono="peligro"
                          tooltip="Quitar este comunicador"
                          (click)="deleteComunicador(i)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>

                      <mat-form-field appearance="outline">
                        <mat-label>Password comunicador</mat-label>
                        <input matInput formControlName="passwordComunicador" />
                        <mat-icon matPrefix>lock</mat-icon>
                      </mat-form-field>

                      <app-modelo-dispositivo-selector
                        tipo="Comunicador"
                        formControlName="idComunicador"
                        [placeholder]="
                          i === 0 && comunicadorRequerido
                            ? 'Modelo de comunicador*'
                            : 'Modelo de comunicador (opcional)'
                        "
                        [showCrearBtn]="
                          helper.tienePermiso(
                            'Configuraciones - Crear modelos comunicadores'
                          )
                        "
                        (modeloChange)="
                          i === 0 ? setFormatoComunicador($event) : null
                        "
                      ></app-modelo-dispositivo-selector>
                    </div>
                  }

                  @if (avisoFormato; as aviso) {
                    <div
                      class="warning-message"
                      [class.info]="aviso.tipo === 'info'"
                    >
                      <mat-icon>
                        {{ aviso.tipo === 'info' ? 'info' : 'warning' }}
                      </mat-icon>
                      <span>{{ aviso.texto }}</span>
                    </div>
                  }

                  <div class="add-button-container">
                    <app-button
                      [matType]="'mat-fab extended'"
                      color="primary"
                      (click)="addComunicador()"
                      text="Comunicador"
                      icon="add"
                    ></app-button>
                  </div>

                  <div class="form-row-2">
                    <!-- Número del Sistema / Número de Serie -->
                    <div class="form-field-wrapper">
                      <mat-form-field appearance="outline" class="no-hint">
                        <mat-label>
                          @if (
                            formatoComunicador === 'Garnet' ||
                            formatoComunicador === 'Garnet-Titanium'
                          ) {
                            Número de Sistema
                          } @else if (
                            formatoComunicador === 'Hikvision' ||
                            formatoComunicador === 'Dahua'
                          ) {
                            Número de Serie
                          } @else {
                            Número de Sistema/Serie
                          }
                        </mat-label>
                        <input
                          matInput
                          formControlName="nroDeSistema"
                          (blur)="validarNroDeSistema($event)"
                        />
                        <mat-icon matPrefix>numbers</mat-icon>
                      </mat-form-field>

                      <!-- Advertencia duplicado nroDeSistema -->
                      @if (warnNroDeSistema) {
                        <div class="warning-message">
                          <mat-icon>warning</mat-icon>
                          <span>
                            Ya existe una alarma con este número de
                            serie/sistema en este cliente.
                          </span>
                        </div>
                      }

                      <!-- Advertencia cuando el campo está vacío -->
                      @if (
                        !formDetallada.get('nroDeSistema')?.value &&
                        formatoComunicador
                      ) {
                        <div class="warning-message">
                          <mat-icon>warning</mat-icon>
                          <span>
                            @if (
                              formatoComunicador === 'Garnet' ||
                              formatoComunicador === 'Garnet-Titanium'
                            ) {
                              Si no se completa el número de sistema, la alarma
                              no funcionará correctamente
                            } @else if (
                              formatoComunicador === 'Hikvision' ||
                              formatoComunicador === 'Dahua'
                            ) {
                              Si no se completa el número de serie, la alarma no
                              funcionará correctamente
                            }
                          </span>
                        </div>
                      }
                    </div>

                    <!-- Frecuencia de comunicación -->
                    <div class="form-field-wrapper">
                      <mat-form-field appearance="outline">
                        <mat-label>Frecuencia de comunicación (min)</mat-label>
                        <input
                          matInput
                          formControlName="frecReporte"
                          required
                        />
                        <mat-icon matPrefix>timer</mat-icon>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </app-content-card>

              <!-- SIMs -->
              <div class="sim-cards-container">
                <app-sim-config
                  [formGroup]="formSim1"
                  title="SIM 1"
                  [operadores]="operadores"
                  [idExcluir]="id"
                ></app-sim-config>

                <app-sim-config
                  [formGroup]="formSim2"
                  title="SIM 2"
                  [operadores]="operadores"
                  [idExcluir]="id"
                ></app-sim-config>
              </div>

              <!-- Credenciales de la alarma (opcional) -->
              <app-content-card
                class="credenciales-alarma-card"
                title="Credenciales de la alarma (opcional)"
                icon="key"
                color="orange"
              >
                <div
                  class="form-content alineado-sim"
                  formGroupName="credencialesAlarma"
                >
                  <p class="hint-text">
                    Si se cargan, se usan estas credenciales para los comandos y
                    consultas de estado de esta alarma. Si se dejan vacías, se
                    usan las credenciales del cliente.
                  </p>
                  <div class="form-row-2">
                    <!-- Usuario -->
                    <mat-form-field appearance="outline">
                      <mat-label>Usuario</mat-label>
                      <input
                        matInput
                        formControlName="usuario"
                        autocomplete="off"
                      />
                      <mat-icon matPrefix>person</mat-icon>
                    </mat-form-field>

                    <!-- Password -->
                    <mat-form-field appearance="outline">
                      <mat-label>Password</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="password"
                        autocomplete="new-password"
                      />
                      <mat-icon matPrefix>lock</mat-icon>
                    </mat-form-field>
                  </div>

                  <div class="form-row-2">
                    <!-- API Key (Hikvision) -->
                    <mat-form-field appearance="outline">
                      <mat-label>API Key</mat-label>
                      <input
                        matInput
                        formControlName="apikey"
                        autocomplete="off"
                      />
                      <mat-icon matPrefix>key</mat-icon>
                    </mat-form-field>

                    <!-- API Secret (Hikvision) -->
                    <mat-form-field appearance="outline">
                      <mat-label>API Secret</mat-label>
                      <input
                        matInput
                        type="password"
                        formControlName="apisecret"
                        autocomplete="new-password"
                      />
                      <mat-icon matPrefix>key</mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </app-content-card>
            </form>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 4: ZONAS -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step optional>
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>grid_view</mat-icon>
                <span>Zonas</span>
              </div>
            </ng-template>

            <div class="step-content">
              <app-content-card
                title="Configuración de Zonas"
                icon="grid_view"
                color="purple"
              >
                <div class="list-container">
                  @if (formInfoZonas.controls.length === 0) {
                    <app-empty-state
                      icon="grid_view"
                      title="Sin zonas configuradas"
                      subtitle="Agregá zonas para organizar los sensores de la alarma"
                    ></app-empty-state>
                  } @else {
                    <div class="zonas-list">
                      @for (
                        f of formInfoZonas.controls;
                        track f;
                        let i = $index
                      ) {
                        <div class="zona-card">
                          <div class="zona-info">
                            <div class="zona-nombre">
                              <mat-icon>grid_view</mat-icon>
                              @if (f.value?.nombre) {
                                {{ f.value?.nombre }}
                              } @else {
                                <span class="no-info">Sin nombre</span>
                              }
                            </div>
                            <div class="zona-meta">
                              <span>
                                <mat-icon>dashboard</mat-icon>
                                Partición:
                                @if (f.value?.particion != null) {
                                  {{ f.value?.particion }}
                                } @else {
                                  <span class="no-info">Sin información</span>
                                }
                              </span>
                              <span>
                                <mat-icon>tag</mat-icon>
                                Zona:
                                @if (f.value?.zona != null) {
                                  {{ f.value?.zona }}
                                } @else {
                                  <span class="no-info">Sin información</span>
                                }
                              </span>
                              @if (f.value?.modo) {
                                <span>
                                  <mat-icon>tune</mat-icon>
                                  {{ f.value.modo }}
                                </span>
                              }
                            </div>
                            @if (f.value?.sensores?.length) {
                              <div class="zona-sensores">
                                @for (s of f.value.sensores; track s) {
                                  <span class="sensor-chip">
                                    <mat-icon>sensors</mat-icon>
                                    @if (s.tipo) {
                                      {{ s.tipo }}
                                    } @else {
                                      <span class="no-info">Sin tipo</span>
                                    }
                                    @if (s.marca) {
                                      · {{ s.marca }}
                                    }
                                  </span>
                                }
                              </div>
                            }
                          </div>
                          <div class="zona-actions">
                            <button
                              irxBotonIcono
                              tooltip="Editar"
                              tono="primario"
                              (click)="editInfoZona(i)"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              irxBotonIcono
                              tooltip="Eliminar"
                              tono="peligro"
                              (click)="deleteInfoZona(i)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="add-button-container">
                    <app-button
                      [matType]="'mat-fab extended'"
                      color="primary"
                      (click)="addInfoZona()"
                      text="Agregar zona"
                      icon="add"
                    ></app-button>
                  </div>
                </div>
              </app-content-card>
            </div>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 5: CÁMARAS (solo con módulo de cámaras habilitado) -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          @if (permisosEntidades.verModuloCamaras()) {
            <mat-step [stepControl]="formCamaras" optional>
              <ng-template matStepLabel>
                <div class="step-label">
                  <mat-icon>videocam</mat-icon>
                  <span>Cámaras</span>
                </div>
              </ng-template>

              <form [formGroup]="formCamaras" class="step-content">
                <app-content-card
                  title="Cámaras Asociadas"
                  icon="videocam"
                  color="green"
                >
                  <div class="list-container">
                    <!-- Selector de cámaras -->
                    <div class="camera-selector">
                      <ng-select
                        [items]="camaras"
                        bindLabel="identificacion"
                        bindValue="_id"
                        formControlName="idsCamaras"
                        placeholder="Selecciona cámaras"
                        [notFoundText]="'No hay cámaras creadas'"
                        [multiple]="true"
                        (change)="asignarCamarasDeAlarma($event)"
                        appendTo="body"
                        [disabled]="!this.formBasica.value.idCliente"
                      ></ng-select>
                      <app-button
                        [disabled]="!this.formBasica.value.idCliente"
                        matType="mat-fab"
                        color="primary"
                        icon="add"
                        (click)="
                          formBasica?.value?.idCliente ? crearCamara() : null
                        "
                      ></app-button>
                    </div>

                    <!-- Lista de cámaras por zona -->
                    @if (camarasForm.controls.length === 0) {
                      <app-empty-state
                        icon="videocam_off"
                        title="Sin cámaras por zona"
                        subtitle="Asocia cámaras a zonas específicas para mejor monitoreo"
                      ></app-empty-state>
                    } @else {
                      <div
                        class="data-grid camaras-grid"
                        cdkDropList
                        (cdkDropListDropped)="drop($event)"
                      >
                        <div class="data-grid-header">
                          <div class="header-cell"></div>
                          <div class="header-cell">Cámara</div>
                          <div class="header-cell">Canal</div>
                          <div class="header-cell">Partición</div>
                          <div class="header-cell">Zona</div>
                          <div class="header-cell actions">Acciones</div>
                        </div>
                        @for (
                          f of camarasForm.controls;
                          track f;
                          let i = $index
                        ) {
                          <div class="data-grid-row" cdkDrag>
                            <div class="drag-handle" cdkDragHandle>
                              <mat-icon>drag_indicator</mat-icon>
                            </div>
                            <div class="cell">
                              {{ nombreCamara(f.value.idCamara) }}
                            </div>
                            <div class="cell">
                              {{
                                nombreCanalCamara(
                                  f.value.idCamara,
                                  f.value.canal
                                )
                              }}
                            </div>
                            <div class="cell">{{ f.value.particion }}</div>
                            <div class="cell">{{ f.value.zona }}</div>
                            <div class="cell actions">
                              <button
                                irxBotonIcono
                                tooltip="Editar"
                                tono="primario"
                                (click)="editCamaraAlarma(i)"
                              >
                                <mat-icon>edit</mat-icon>
                              </button>
                              <button
                                irxBotonIcono
                                tooltip="Eliminar"
                                tono="peligro"
                                (click)="deleteCamaraAlarma(i)"
                              >
                                <mat-icon>delete</mat-icon>
                              </button>
                            </div>
                          </div>
                        }
                      </div>
                    }
                    <div class="add-button-container">
                      <app-button
                        [matType]="'mat-fab extended'"
                        color="primary"
                        (click)="addCamara()"
                        text="Cámara por zona"
                        icon="add"
                      ></app-button>
                    </div>
                  </div>
                </app-content-card>
              </form>
            </mat-step>
          }

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 6: CONTACTOS -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step errorMessage="Campos incompletos" optional>
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>contacts</mat-icon>
                <span>Contactos</span>
              </div>
            </ng-template>

            <div class="step-content">
              <app-content-card
                title="Contactos de Emergencia"
                icon="contacts"
                color="red"
              >
                <div class="list-container">
                  @if (contactosForm.controls.length === 0) {
                    <app-empty-state
                      icon="person_off"
                      title="Sin contactos configurados"
                      subtitle="Agregá contactos para recibir notificaciones de la alarma"
                    ></app-empty-state>
                  } @else {
                    <div class="data-grid contactos-grid">
                      <div class="data-grid-header">
                        <div class="header-cell">Contacto</div>
                        <div class="header-cell">Email</div>
                        <div class="header-cell">Teléfono</div>
                        <div class="header-cell">Partición</div>
                        <div class="header-cell priority">Prioridad</div>
                        <div class="header-cell actions">Acciones</div>
                      </div>
                      @for (item of contactosOrdenados; track item.ctrl) {
                        <div class="data-grid-row">
                          <div class="cell">
                            @if (item.ctrl.value.informacion?.contacto) {
                              {{ item.ctrl.value.informacion?.contacto }}
                            } @else {
                              <span class="no-info">Sin contacto</span>
                            }
                          </div>
                          <div class="cell">
                            @if (item.ctrl.value.informacion?.email) {
                              {{ item.ctrl.value.informacion?.email }}
                            } @else {
                              <span class="no-info">Sin email</span>
                            }
                          </div>
                          <div class="cell">
                            @if (item.ctrl.value.informacion?.telefono) {
                              {{ item.ctrl.value.informacion?.telefono }}
                            } @else {
                              <span class="no-info">Sin teléfono</span>
                            }
                          </div>
                          <div class="cell">
                            @if (
                              item.ctrl.value.informacion?.particion !== null &&
                              item.ctrl.value.informacion?.particion !==
                                undefined
                            ) {
                              {{ item.ctrl.value.informacion?.particion }}
                            } @else {
                              <span class="no-info">Sin partición</span>
                            }
                          </div>
                          <div class="cell priority">
                            <span class="priority-badge">
                              @if (item.ctrl.value.orden) {
                                {{ item.ctrl.value.orden }}
                              } @else {
                                <span class="no-info">Sin información</span>
                              }
                            </span>
                          </div>
                          <div class="cell actions">
                            @if (!item.ctrl.value.nuevo) {
                              <button
                                irxBotonIcono
                                tooltip="Ver"
                                (click)="verDetallesContacto(item.i)"
                              >
                                <mat-icon>visibility</mat-icon>
                              </button>
                            }
                            <button
                              irxBotonIcono
                              tooltip="Editar"
                              tono="primario"
                              (click)="editNota_Contacto(item.i)"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              irxBotonIcono
                              tooltip="Eliminar"
                              tono="peligro"
                              (click)="deleteNota_Contacto(item.i)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="add-button-container">
                    <app-button
                      [matType]="'mat-fab extended'"
                      color="primary"
                      (click)="addNota_Contacto()"
                      text="Agregar contacto"
                      icon="person_add"
                    ></app-button>
                  </div>
                </div>
              </app-content-card>
            </div>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 7: NOTAS -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step errorMessage="Campos incompletos" optional>
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>notes</mat-icon>
                <span>Notas</span>
              </div>
            </ng-template>

            <div class="step-content">
              <app-content-card
                title="Notas e Instrucciones"
                icon="notes"
                color="yellow"
              >
                <div class="list-container">
                  @if (notasForm.controls.length === 0) {
                    <app-empty-state
                      icon="note_alt"
                      title="Sin notas configuradas"
                      subtitle="Agregá notas importantes sobre la alarma o el cliente"
                    ></app-empty-state>
                  } @else {
                    <div class="data-grid notas-grid">
                      <div class="data-grid-header">
                        <div class="header-cell flex-2">Nota</div>
                        <div class="header-cell">Partición</div>
                        <div class="header-cell">Prioridad</div>
                        <div class="header-cell actions">Acciones</div>
                      </div>
                      @for (f of notasForm.controls; track f; let i = $index) {
                        <div class="data-grid-row">
                          <div class="cell flex-2 note-text">
                            @if (f.value?.informacion?.nota) {
                              {{ f.value?.informacion?.nota }}
                            } @else {
                              <span class="no-info">Sin nota</span>
                            }
                          </div>
                          <div class="cell">
                            @if (
                              f.value?.informacion?.particion !== null &&
                              f.value?.informacion?.particion !== undefined
                            ) {
                              {{ f.value?.informacion?.particion }}
                            } @else {
                              <span class="no-info">Sin partición</span>
                            }
                          </div>
                          <div class="cell priority">
                            <span class="priority-badge">
                              @if (f.value?.orden) {
                                {{ f.value?.orden }}
                              } @else {
                                <span class="no-info">Sin información</span>
                              }
                            </span>
                          </div>
                          <div class="cell actions">
                            <button
                              irxBotonIcono
                              tooltip="Editar"
                              tono="primario"
                              (click)="editNota_Nota(i)"
                            >
                              <mat-icon>edit</mat-icon>
                            </button>
                            <button
                              irxBotonIcono
                              tooltip="Eliminar"
                              tono="peligro"
                              (click)="deleteNota_Nota(i)"
                            >
                              <mat-icon>delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div class="add-button-container">
                    <app-button
                      [matType]="'mat-fab extended'"
                      color="primary"
                      (click)="addNota_Nota()"
                      text="Agregar nota"
                      icon="note_add"
                    ></app-button>
                  </div>
                </div>
              </app-content-card>
            </div>
          </mat-step>

          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <!-- STEP 8: CONTROL HORARIO -->
          <!-- ═══════════════════════════════════════════════════════════════════ -->
          <mat-step [stepControl]="formControlHorario" optional>
            <ng-template matStepLabel>
              <div class="step-label">
                <mat-icon>schedule</mat-icon>
                <span>Horario</span>
              </div>
            </ng-template>

            <form [formGroup]="formControlHorario" class="step-content">
              <app-content-card
                title="Control Horario"
                icon="schedule"
                color="blue"
              >
                <div class="list-container">
                  <!-- Estado y controles -->
                  <div class="horario-controls">
                    <div class="status-toggle">
                      <mat-slide-toggle
                        color="primary"
                        [checked]="controlHorarioActivo"
                        [disabled]="horariosForm.controls.length === 0"
                        (change)="toggleControlHorario()"
                        class="control-horario"
                      >
                        <span class="toggle-label">
                          @if (controlHorarioActivo) {
                            <mat-icon class="toggle-icon active">
                              check_circle
                            </mat-icon>
                            Control Horario Activo
                          } @else {
                            <mat-icon class="toggle-icon">schedule</mat-icon>
                            Control Horario Desactivado
                          }
                        </span>
                      </mat-slide-toggle>

                      @if (horariosForm.controls.length === 0) {
                        <app-hint
                          icon="info"
                          message="Para activar el control horario, primero debe crear al menos un horario"
                          color="red"
                        ></app-hint>
                      }
                    </div>
                    @if (horariosForm.controls.length > 0) {
                      <app-button
                        matType="mat-fab"
                        color="primary"
                        icon="calendar_month"
                        (click)="verVisualizadorHorario()"
                      ></app-button>
                    }

                    <!-- Checkboxes de configuración -->
                    <div class="horario-checkboxes">
                      <mat-checkbox
                        color="primary"
                        formControlName="ignorarArmadosFueraDeHorario"
                      >
                        <mat-icon>lock</mat-icon>
                        Ignorar armados fuera de horario
                      </mat-checkbox>
                      <mat-checkbox
                        color="primary"
                        formControlName="ignorarDesarmadosFueraDeHorario"
                      >
                        <mat-icon>lock_open</mat-icon>
                        Ignorar desarmados fuera de horario
                      </mat-checkbox>
                    </div>

                    <div
                      style="display: flex; flex-direction: column; gap: 12px"
                    >
                      <app-button
                        [matType]="'mat-fab extended'"
                        color="primary"
                        (click)="addHorario()"
                        text="Agregar horario"
                        icon="add"
                      ></app-button>
                    </div>
                  </div>

                  <!-- Columnas de Aperturas y Cierres -->
                  <div class="horario-columns">
                    <!-- Aperturas -->
                    <div class="horario-column apertura">
                      <h3 class="column-title apertura">
                        <mat-icon>lock_open</mat-icon>
                        Aperturas
                      </h3>
                      @if (getHorariosAperturas().length === 0) {
                        <div class="empty-horarios">
                          Sin aperturas configuradas
                        </div>
                      } @else {
                        <div
                          class="horarios-list"
                          cdkDropList
                          (cdkDropListDropped)="dropHorarios($event)"
                        >
                          @for (
                            item of getHorariosAperturas();
                            track item.control
                          ) {
                            <div class="horario-card" cdkDrag>
                              <div class="horario-info">
                                <div class="horario-dias">
                                  <mat-icon>event</mat-icon>
                                  {{ formatearDias(item.control.value?.dias) }}
                                </div>
                                <div class="horario-hora">
                                  <mat-icon>access_time</mat-icon>
                                  {{ formatearHora(item.control.value?.hora) }}
                                </div>
                                <div class="horario-tolerancia">
                                  <mat-icon>timelapse</mat-icon>
                                  {{
                                    formatearTolerancia(
                                      item.control.value?.toleranciaAntes,
                                      item.control.value?.toleranciaDespues
                                    )
                                  }}
                                </div>
                                @if (
                                  item.control.value?.particion !== null &&
                                  item.control.value?.particion !== undefined
                                ) {
                                  <div class="horario-particion">
                                    <mat-icon>dashboard</mat-icon>
                                    Partición:
                                    {{ item.control.value?.particion }}
                                  </div>
                                }
                              </div>
                              <div class="horario-actions">
                                <button
                                  irxBotonIcono
                                  tooltip="Editar"
                                  tono="primario"
                                  (click)="editHorario(item.index)"
                                >
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <button
                                  irxBotonIcono
                                  tooltip="Eliminar"
                                  tono="peligro"
                                  (click)="deleteHorario(item.index)"
                                >
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>

                    <!-- Cierres -->
                    <div class="horario-column cierre">
                      <h3 class="column-title cierre">
                        <mat-icon>lock</mat-icon>
                        Cierres
                      </h3>
                      @if (getHorariosCierres().length === 0) {
                        <div class="empty-horarios">
                          Sin cierres configurados
                        </div>
                      } @else {
                        <div
                          class="horarios-list"
                          cdkDropList
                          (cdkDropListDropped)="dropHorarios($event)"
                        >
                          @for (
                            item of getHorariosCierres();
                            track item.control
                          ) {
                            <div class="horario-card" cdkDrag>
                              <div class="horario-info">
                                <div class="horario-dias">
                                  <mat-icon>event</mat-icon>
                                  {{ formatearDias(item.control.value?.dias) }}
                                </div>
                                <div class="horario-hora">
                                  <mat-icon>access_time</mat-icon>
                                  {{ formatearHora(item.control.value?.hora) }}
                                </div>
                                <div class="horario-tolerancia">
                                  <mat-icon>timelapse</mat-icon>
                                  {{
                                    formatearTolerancia(
                                      item.control.value?.toleranciaAntes,
                                      item.control.value?.toleranciaDespues
                                    )
                                  }}
                                </div>
                                @if (
                                  item.control.value?.particion !== null &&
                                  item.control.value?.particion !== undefined
                                ) {
                                  <div class="horario-particion">
                                    <mat-icon>dashboard</mat-icon>
                                    Partición:
                                    {{ item.control.value?.particion }}
                                  </div>
                                }
                              </div>
                              <div class="horario-actions">
                                <button
                                  irxBotonIcono
                                  tooltip="Editar"
                                  tono="primario"
                                  (click)="editHorario(item.index)"
                                >
                                  <mat-icon>edit</mat-icon>
                                </button>
                                <button
                                  irxBotonIcono
                                  tooltip="Eliminar"
                                  tono="peligro"
                                  (click)="deleteHorario(item.index)"
                                >
                                  <mat-icon>delete</mat-icon>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <mat-divider style="margin: 16px 0"></mat-divider>
                  <app-page-title
                    [title]="'Excepciones'"
                    color="gray"
                    style="display: flex; justify-content: center"
                  ></app-page-title>
                  <!-- Listado de excepciones -->
                  <app-listado-excepciones
                    [tipoExcepcion]="'Control Horario'"
                    [tipoEntidad]="'Alarma'"
                    [idEntidad]="id || undefined"
                    [buffer]="id ? undefined : excepcionesBuffer"
                    (bufferChange)="excepcionesBuffer = $event"
                  ></app-listado-excepciones>
                </div>
              </app-content-card>
            </form>
          </mat-step>
        </mat-stepper>
      </mat-card-content>
    </mat-card>
  }

  @if (this.formBasica && this.formDetallada && stepper) {
    <ng-container actions>
      <button irxBoton="secundario" type="button" (click)="volver()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      @let completa =
        formBasica.valid && formDetallada.valid && formUbicacion.valid;
      <!-- Con la alarma completa, Guardar es la acción principal y Siguiente
           pasa a secundario -->
      @if (!ultimo && completa) {
        <button irxBoton="secundario" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      } @else if (!ultimo) {
        <button irxBoton="principal" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      @if (completa || ultimo) {
        <button
          irxBoton="principal"
          type="button"
          (click)="guardarAlarma()"
          [disabled]="guardando || !completa"
        >
          <mat-icon>check</mat-icon>
          {{ guardando ? 'Guardando…' : 'Guardar alarma' }}
        </button>
      }
    </ng-container>
  }
</app-crear-editar>
